import './index.scss';
const $ = require('jquery');
import store from './store';
import util from './util';
import video from './videoplayer';
import youtube from './youtubeplayer';
import layer from './layer';
import sequenceplayer from './sequenceplayer'


$('body').addClass('promokit')
         .addClass(`promokit--${store('device')}`)
         .addClass(`promokit--${store('browser')}`)
         .addClass(`promokit--${store('os')}`);

$(document).ready(() => {
  if (!store('isPreload')) {
    $('body').addClass('promokit--ready');
    $(document).trigger('promokitready');
    $(window).trigger('resize');
  }
});

export default {
  store,
  util,
  layer,
  video,
  youtube,
  sequenceplayer,


};
